module.exports = __webpack_public_path__ + "static/media/codeHeader.227575c4.jpg";